export default __webpack_public_path__ + "static/media/female.e4ee6b0d.jpeg";